import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import Point from './Point';
import Postpay from './Postpay';
import EpApiCalculate from './EpApiCalculate';
import EpApiCalculateDetail from './EpApiCalculateDetail';
import HologramBanner from './HologramBanner';
import HologramBannerDetail from './HologramBannerDetail';


const RevenueManag = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="SalesStatistics"
        tabMenuList={tabList()}
        tabs={{
          '/sales/revenue/main': { tabComponent: <Statistics/> },
          '/sales/revenue/point': { tabComponent: <Point/> },
          '/sales/revenue/postpay': { tabComponent: <Postpay/> },
          '/sales/revenue/epApi': { tabComponent: <EpApiCalculate/> },
          '/sales/revenue/epApiDetail': { isPop: 1, tabComponent: <EpApiCalculateDetail/> },
          '/sales/revenue/hologramBanner': { tabComponent: <HologramBanner/> },
          '/sales/revenue/hologramBannerDetail': { isPop: 1, tabComponent: <HologramBannerDetail/> },
        }}
      />
    </MainTemplate>
  );
};

export default RevenueManag;
